const TestTaskDetail = () => import("@/pages/lab/testtask/TestTaskDetail");
const TestTaskEdit = () => import("@/pages/lab/testtask/TestTaskEdit");

export class TestTaskRoutes {
  constructor() {
    this.route_root = "test-tasks/";
    this.type_single = "Test Task";
    this.type_plural = "Test Tasks";

    this.routes = [
      {
        path: `${this.route_root}/:test_task_id`,
        name: `View ${this.type_single}`,
        component: TestTaskDetail,
        meta: { requiresAuth: true },
      },
      {
        path: `${this.route_root}/:test_task_id/edit`,
        name: `Update ${this.type_single}`,
        component: TestTaskEdit,
        meta: { requiresAuth: true },
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
